import { InjectionToken } from '@angular/core';

export interface PcsDndConfig {
  dragOverClass: string;
  droppableDisabledClass: string;
  draggingSourceClass: string;
  draggableDisabledClass: string;
  droppableClass: string;
}

export const DndConfig = new InjectionToken<PcsDndConfig>('DndConfig');
